/* eslint-disable no-prototype-builtins */
import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isInIframe(): boolean {
  if (typeof window === 'undefined') return false;
  return window.self !== window.top;
}

export const hasValidKey = (obj: { [key: string]: any }, key: string) =>
  obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined;